import individualDataMonitor from "../individualDataMonitor/IndividualDataMonitor";
import dmUtil from "../dataMonitor/dataMonitorUtil";

export default {
  name: "multipleDataMonitor",

  extends: individualDataMonitor,

  data() {
    return {
      // DM機能の設定インスタンス。マルチデータモニタ用に上書き
      dataMonitorFunctionSettings: new dmUtil.DataMonitorFunctionSettings(dmUtil.TYPE_CALLER.MULTI_DM),
      // マルチデータモニタの機能名に上書き
      navItemLabel: "message.label_menu_multi_data_monitor",
    };
  },

  // 以下のvue routerのhookは継承元を参照しないため、子コンポーネントでも同じものを追加

  /**
   * 遷移してきた画面のパラメータ情報を保持
   */
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      vm.beforeRouteProcess(vm, from);
    });
  },

  /**
   * 遷移してきた画面のパラメータ情報を保持
   * 同一コンポーネントが再帰的に利用された場合、呼び出される
   */
  beforeRouteUpdate(to, from, next) {
    if (this.isPopstateNavigation) {
      this.cacheIsPopstateNavigation(false);
      next();
      return;
    }
    this.$nextTick(() => {
      // 遷移してきたときのコンポーネント内ガード共通処理
      this.beforeRouteProcess(this, from);
      // mounted時に行う共通処理を呼び出す
      this.mountedLogic();
    });
    next();
  },

  /** 画面遷移時、計測中か判定 */
  beforeRouteLeave(to, from, next) {
    if ((to.name === "login") && (to.fullPath === "/") && (to.path === "/")) {
      this.$refs.data_monitor.setSignout();
      next();
      return;
    }
    if (to.name === "changeUnit") {
      if (!this.showSelect) {
        // 単位設定は移動不可
        this.changeUnitAlert();
        return;
      }
    }
    // 計測中は移動不可
    if (this.inExecution) {
      this.inExecutionAlert();
    } else {
      this.showSelect = true;
      next();
    }
  },
};